// Simple SVG donut chart. No external deps.
export function DonutChart({ data, size = 200, thickness = 32, centerLabel, centerValue }) {
  const total = data.reduce((a, d) => a + d.value, 0);
  if (total === 0) {
    return (
      <div className="flex items-center justify-center text-sm text-[color:var(--sp-text-muted)]" style={{ width: size, height: size }}>
        Nessun dato
      </div>
    );
  }
  const r = (size - thickness) / 2;
  const cx = size / 2;
  const cy = size / 2;
  const circumference = 2 * Math.PI * r;

  let acc = 0;
  const segments = data.map((d) => {
    const frac = d.value / total;
    const dash = frac * circumference;
    const gap = circumference - dash;
    const rot = (acc / total) * 360;
    acc += d.value;
    return { ...d, dash, gap, rot };
  });

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
      <circle cx={cx} cy={cy} r={r} fill="none" stroke="var(--sp-subtle)" strokeWidth={thickness} />
      {segments.map((s, i) => (
        <circle
          key={i}
          cx={cx}
          cy={cy}
          r={r}
          fill="none"
          stroke={s.color}
          strokeWidth={thickness}
          strokeDasharray={`${s.dash} ${s.gap}`}
          strokeDashoffset={0}
          transform={`rotate(${s.rot - 90} ${cx} ${cy})`}
          style={{ transition: "stroke-dasharray 400ms ease-out" }}
        />
      ))}
      {centerValue && (
        <>
          {centerLabel && (
            <text x={cx} y={cy - 10} textAnchor="middle" className="fill-[color:var(--sp-text-muted)]" style={{ fontFamily: "Onest", fontSize: 10, fontWeight: 900, letterSpacing: "0.15em", textTransform: "uppercase" }}>
              {centerLabel}
            </text>
          )}
          <text x={cx} y={cy + 14} textAnchor="middle" className="fill-[color:var(--sp-text)]" style={{ fontFamily: "Onest", fontSize: 20, fontWeight: 900 }}>
            {centerValue}
          </text>
        </>
      )}
    </svg>
  );
}
